<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="total-feul-load"
                    pagination="server"
                    search>
                        <template #filters>
                            <total-fuel-load-filter v-on:filter="filter($event)"></total-fuel-load-filter>
                        </template>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-3">
                                    <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y',mode:'range', dateFormat: 'Y-m-d',locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
                                </div>
                                <div class="col-md-auto col-12">
                                    <button class="btn btn-success w-100" v-on:click="$refs.table.refresh()">
                                        Sorgula
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template #custom-html>
                            <div class="row px-1 py-0">
                                <div class="col-md-3 mb-1">
                                    <v-stats-box text="Toplam Tutar" variant="success" icon="currency_lira" :value="stats.TotalAmount" short-text="Vergi Dahil"></v-stats-box>
                                </div>
                                <div class="col-md-3 mb-1">
                                    <v-stats-box text="Toplam Tutar" variant="danger" icon="currency_lira" :value="stats.TotalAmountWithoutTax" short-text="Vergi Hariç"></v-stats-box>
                                </div>
                                <div class="col-md-3 mb-1">
                                    <v-stats-box text="Toplam Yakıt Litresi" variant="secondary" icon="oil_barrel" :value="stats.TotalLiter"></v-stats-box>
                                </div>
                                <div class="col-md-3 mb-1">
                                    <v-stats-box text="Toplam Yükleme Sayısı" variant="warning" icon="local_gas_station" :value="stats.Count"></v-stats-box>
                                </div>
                            </div>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FuelOperationApi from '@/api/fuel-operations'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import moment from 'moment'
import VStatsBox from '@/components/VStatsBox.vue'
import TotalFuelLoadFilter from './components/TotalFuelLoadFilter'

export default {
    components:{
        BCard,
        flatPickr,
        VStatsBox,
        TotalFuelLoadFilter
    },
    data(){
        return{
            fields:[
                {name:'Filo',key:'FleetName',thClass:'w-8',tdClass:'text-nowrap',sortable:true,sortKey:'FleetCode.Name'},
                {name:'Araç',key:'Plate',thClass:'w-10',sortable:true,sortKey:'Plaka'},
                {name:'Plaka Tanımlı Mı?',key:'PlateIsDefined',thClass:'w-10',sortable:true,sortKey:'PlateId'},
                {name:'Tarih',key:'ProcessDate',thClass:'w-10',tdClass:'text-nowrap',sortable:true,sortKey:'IslemTarihi'},
                {name:'Fatura Dönemi',key:'InvoicePeriod',thClass:'w-10',sortable:true,sortKey:'FaturaDonemi'},
                {name:'Lokasyon',key:'Location',thClass:'w-20',sortable:true,sortKey:'Lokasyon',tdClass:'text-nowrap'},
                {name:'İstasyon',key:'Station',thClass:'w-10',tdClass:'text-nowrap',sortable:true,sortKey:'Istasyon'},
                {name:'Yakıt Tipi',key:'FuelType',thClass:'w-8',tdClass:'text-nowrap',sortable:true,sortKey:'YakitTuru'},
                {name:'Fiyat (LT/TL)',key:'Price',thClass:'w-8',sortable:true,sortKey:'BirimFiyat'},
                {name:'Litre',key:'Liter',thClass:'w-8',sortable:true,sortKey:'Litre'},
                {name:'Tutar (TL)',key:'TotalAmount',thClass:'w-8',sortable:true,sortKey:'Miktar'},
            ],
            dateRange:null,
            filteredData:{
                InvoicePeriods:[],
                Fleets:[],
                Plates:[],
                IsPlateDefined:null
            },
            stats:{
                TotalLiter:null,
                TotalAmount:null,
                TotalAmountWithoutTax:null,
                Count:null
            }
        }
    },
    created(){
        this.dateRange = this.c_month
    },
    methods:{
        filter(filter){
            this.filteredData = filter
            this.$refs.table.refresh()
        },
        provider(data){
            this.getStats()
            return FuelOperationApi.TotalFuelLoadTable({
                ...this.c_dates,
                InvoicePeriods:this.filteredData.InvoicePeriods,
                Fleets:this.filteredData.Fleets,
                Plates:this.filteredData.Plates,
                IsPlateDefined:this.filteredData.IsPlateDefined,
                PaginationRequestModel:data
            })
        },
        getStats(){
            FuelOperationApi.TotalFuelLoadStats({
                    ...this.c_dates,
                    IsPlateDefined:this.filteredData.IsPlateDefined,
                    InvoicePeriods:this.filteredData.InvoicePeriods,
                    Fleets:this.filteredData.Fleets,
                    Plates:this.filteredData.Plates
                }).then(res=>{
                this.stats = res.data.Data
            })
        }
    },
    computed:{
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
        c_month(){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"),moment(lastDay).format("YYYY-MM-DD")].join(" - ")
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>